import motherrabbit from "../Assets/Covers/MotherRabbit.jpg"
import missingrain from "../Assets/Covers/MissingTheRain.webp"
import rip from "../Assets/icons/coffin.webp"
import cereal from "../Assets/icons/cereal.png"
import apartment from "../Assets/icons/building.png"
import pitch from "../Assets/icons/pitch-deck.png"
import hottub from "../Assets/icons/bathtub.png"

const plays = [
    {
        title: "Mother Rabbit",
        style: "Comedy",
        length: "2 acts",
        year: 2025,
        status: "available",
        synopsis: `Peter Kotski's mother is sick. His father passed away years ago. 
        His eccentric brothers are eccentric, and estranged. His mother's illness 
        brings them all together again, where they must reconcile with each other, 
        and her infamous personal Doctor, Reverend Byrd. Filled with boisterous energy
        shenanigans, and all sorts of tomfoolery, Mother Rabbit has a laugh for anyone
        who comes. The show is Family-friendly and has strong themes of forgiveness and 
        family values.`,
        sample: `PETER "What church do you belong to?\nKEIRA "First Presbyterian Church."\nRICHARD "You’re the first?"\nKEIRA "Of its kind, yes."\nBOBBY "You’re fish people?"\nPETER "Excuse him, he hasn’t eaten."\nBOBBY "You stay out of this."\nRICHARD "What did you say you were?"\nKEIRA "Presbyterian."\nRICHARD "I don’t know what that is."\nBOBBY "It means they eat fish."\nKEIRA "No, that's Pescatirian."\nBOBBY "What did you just call me?"\nBYRD "No, Pescatarian."\nBOBBY "So you’re an exterminator."`,
        // purchaseUrl: "#",
        icon: motherrabbit,
        author: "Benjamin Gagliardi"
    },
    {
        title: "Missing the Rain",
        style: "Drama",
        length: "2 acts",
        year: 2024,
        status: "available",
        synopsis: "Lisa's family is coming apart, or maybe it already has. Her brother, Logan, and his friends visit for one last birthday party for their father. Lenny needs a break, Manny needs something to do, and a storm is coming.",
        sample: `PRIDANE "The house is swallowing me, Lisa! Everywhere I turn there’s a wall, And that’s the worst goddamn one. It’s looming."\nLISA "Will you stop with the swearing? There’s twenty feet between you and that wall."\nPRIDANE "No there isn’t."\nLISA "Yes there is. You’re only making a fuss because you shoved your desk into the corner of the room again. I get that you hate small spaces, so why do you keep pushing your desk into the corner?"\nPRIDANE "It’s the only place with any good light."\nLISA "You threw away paper with nothing on it."\nPRIDANE "I almost wrote something terrible, I had to throw it away."\nLISA "No, you absolutely did not. Stop being so dramatic."`,
        // purchaseUrl: "#",
        icon: missingrain,
        author: "Benjamin Gagliardi"
    },
];

const skits = [
    {
        title: "The Eulogy",
        style: "Comedy",
        year: 2023,
        synopsis: "A neurotic and strange man performs a ridiculous Eulogy. Short-form comedy, approximately 4 minutes.",
        sample: `It says he was a Cadet, which I always thought was a type of bird, but no, he fought very patriotically for us. And he fought in many places in the world including (Reads) here in the U.S. and (Reads) Bulimia. He was very brave, he was also very intelligent. These are educated guesses. Travis was probably better than me at almost everything except not dying.`,
        // purchaseUrl: "#",
        status: "available",
        icon: rip,
        author: "Benjamin Gagliardi"
    },
    {
        title: "Breakfast Conversations",
        style: "Comedy",
        year: 2021,
        synopsis: "Two people at a morning breakfast table. They begin to argue over what to do when a deer gets in front of your car. Heavily inspired by Abbott and Costello, approximately 6 minutes.",
        sample: `BOBBY: I could be the next Martin Luther King.\nROBERT: Well, I think you’d need a little bit more than a PhD in English.\nBOBBY: Right, I'd need to dye my hair.\nRICHARD: You’d need to dye your whole body.\nBOBBY: That’s racist.\nRICHARD: That is not racist.\nBOBBY: That’s what a racist would say.`,
        // purchaseUrl: "#",
        status: "available",
        icon: cereal,
        author: "Benjamin Gagliardi"
    },
];

const screenplays = [
    {
        title: "The Apartment",
        style: "Comedy",
        year: 2022,
        synopsis: "Bobby Ryan makes a breakthrough with bomb proofing furniture, much to the chagrin of his roommate. Short-form screenplay, approximately 24 pages.",
        sample: `BOBBY 'Well then I said “that fruit salad reminds me of your daughter, because she’s the worst thing here”'\nDOUG 'And what did the dad say to that?'\nBOBBY 'Oh he goes, “I don’t care if you’re the best man, you’re outta here!”'`,
        icon: apartment,
        author: "Benjamin Gagliardi"
    },
    {
        title: "The Pitch",
        style: "Comedy",
        year: 2021,
        synopsis: "Bobby Ryan is struggling to succeed as an entrepaneur, when he bumps into an old friend. Short-form, approximately 17 pages.",
        sample: `BOBBY "Well they loved me Richard, but it just didn’t work out."\nRICHARD "Why?"\nBOBBY "They didn’t like me so much"\nRICHARD "Did you pitch the wrist brace?"\nBOBBY "No, I pitched Edible cell phones…"\nRICHARD "Oh, yeah...? [confused, disappointed]"\nBOBBY "Yeah... some guy accidentally ate his actual phone"`,
        icon: pitch,
        author: "Benjamin Gagliardi"
    },
    {
        title: "The Interview",
        style: "Comedy",
        year: 2020,
        synopsis: "Bobby Ryan is interviewed by the local news about his travelling hot tub business. Short-form, approximately 3 pages.",
        sample: `They have four sides, like four personalities--it’s like buying a schizophrenic masseuse! They come in all sorts of a color: Gray, Blue-Gray, Dark-Gray, Neon-Gray and obviously during the month of June, the Gay-Gray.`,
        icon: hottub,
        author: "Benjamin Gagliardi"
    },
];

// const poems = [
//     {
//         title: "Wasn't It Nice?",
//         style: "Drama",
//         year: 2026,
//         lines: `What do you do once a flower has bloomed,\nAnd you’ve smiled enough to give it its due,\nAnd you’ve smelled until it doesn’t smell new,\nAnd all it has left is dying to do?\n\nDo you find a new friend, forget its name,\nOr look for another, almost the same?\nShould you throw it away, move on despite\nThe petals that cling to leftover life?\n\nCan I love it the same now that it fades,\nWilts in its vase, and in stale water wades?\nIs it not worse to smell all the decay,\nThan to remember its smell yesterday?\n\nIf it never dies, was it ever real?\nIf it withers now, did I ever feel,\nAnything more than vanity’s powers?\nI don’t know if I should grow more flowers.\n\nA willow tree with its long wizened vines,\nDoes whisper the wind and sagely opines,\nNot to let rot, but lay good things to rest,\nAnd moving on, not moving to, is best.\n\nBut quaking aspen, with trepidation,\nAnd shaking, asking, for explanation,\nWhat if I move on to weeds or thickets?\nWhat if I don’t attract bees, but crickets?\n\nI don’t trust the weeping, blinded by tears,\nNeither the quivering crippled with fears,\nStill both stir with wind, and let the breeze through,\nWhere that wind finds me I’ll know what to do.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Packing For Tomorrow",
//         style: "Drama",
//         year: 2026,
//         lines: `I feel the cold floor under my curled toes,\nMy heart begins to race but plugs its ears,\nAs if to say that it already knows,\nThe race began, but didn’t want to hear,\nThe starting pistol to pack everything,\nAnd leave home with no plan of returning.`,
//         author:"Benjamin Gagliardi"
//     },
//     {
//         title: "Desolation Day",
//         style: "Drama",
//         year: 2026,
//         lines: `You hear a tick, you’re going back\nAnother click, and every tap,\nAgainst your head, is like a clock\nThat’s made of lead, and heavy tocks,\nThat loudly snap, their poison clack,\nUntil they trap your every thought.\n\nYou hear clear what it has to say,\nAnd struggle here not to obey.\nNow you’re seven seconds away,\nFrom starting desolation day.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Grocery Store",
//         style: "Romantic",
//         year: 2026,
//         lines: `I do not know love anymore,\nAt least not like I did before,\nThat part of me was killed last year,\nIn my hometown grocery store.\n \nHow could I know that I should fear,\nTo walk the aisles with her here?\nTo wander with her hand in mine,\nBetween the frozen food and beer?\n \nShe posed under the ‘Asian’ sign,\nAnd laughed and twirled and skipped aside,\nJoyful, and then I felt it die,\nAnd even argued time to time.\n \nA thousand tiny cuts made by\nA thousand twinkles in her eye,\nImperfect moments interleaved\nWith a perfect smile and happy sigh.\n \nLove’s innocent and more naive,\nThan I could ever have believed,\nNot grand, or planned, ideal, or clean,\nJust careless joy with her between.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Abroad",
//         style: "Drama",
//         year: 2026,
//         lines: `A familiar sun crawls over new leaves\nAnd lays down on smooth bark, heaving sighs of\ncold wind that lifts your scarf just like at home.\nEvery color you see is an old friend,\nShowing off a different hat and coat,\nAnd you wonder how it is that you could\nknow so many strangers when you travel.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Alunalei",
//         style: "Romantic",
//         year: 2025,
//         lines: `I wish there were two: The cold moon and you.\nOr that you’d take its place, my own Selûne.\nFor the shadows shatter, and cold takes flight,\nIf you were the moon, seated in the night.\n\nYour calm, pale, countenance that comes from\nReflections of prisms in the sun.\nBe my moonlight. My sacred starlight,\nWash me in the colors of your sight.\n\nMake your celestial winds batter my soul,\nAnd carry vestal sighs that take control.\nThey build a Heavenly fire in the choir,\nOf your voice, in fearsome hymn’s gentle noise.\n\nI kneel in terror at the thought of you,\nMy insurmountable gratitude.\nAt your impossible mountain of grace,\nAt the Maker’s light shining through your face.\n\nI hear His whisper in every shiver\nOf your breath.\nI clutch Love’s quiver, fixed forever\nUntil my death.\nFor my heart beats and beats and breaks itself,\nAgainst my chest.\n\nYet the Lord held me fast from all alarms,\nHands that made you, have placed you in my arms.`,
//         author: "Benjamin Gagliardi"
//     },
//     // {
//     //     title: "Crosby Drive",
//     //     style: "Drama",
//     //     year: 2025,
//     //     lines: "",
//     //     author: "Benjamin Gagliardi"
//     // },
//     {
//         title: "Love for You",
//         style: "Drama",
//         year: 2025,
//         lines: `A Poem to My Mother\n\nOh, if love were but a thing I could leave behind,\nA box, or ring, or thing of any kind,\nI’d part with every trace and trinket I could find,\nA hundred loves and more to you consigned.\n\nIf love were but a vision I could make you see,\nYour rooms and halls would never be empty\nFor we, our kids, and even the angels would be\nPlaying in those halls eternally.\n\nIf love were but a music I could make you hear,\nYou’d never wake alone in quiet fear\nThat no one’s near, for all your kindness so sincere\nWould echo back upon your ear.\n\nIf love were but a scent or smell that you would know,\nI’d bring you back a long, long time ago,\nWhere forgotten feelings of flowers and trees smell so\nSweet, and mem’ries, like wind, come to and fro\n\nIf love were but a dinner I could share with you,\nThe table would seat every soul with whom\nYou’ve ever loved, and all manner of hearty food,\nTasting speech, eating words, and thoughts we chew.\n\nIf love were but more worldly, all the world I’d give,\nIf love were but this life, then you’d forever live,\nBut love’s vastly more than any gift of my own,\nAnd only hands of heaven would make it known.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Stormclouds",
//         style: "Drama",
//         year: 2024,
//         lines: `Dark clouds grow, grow and growl,\nAnd hail the coming of the rain.\nThunder rolls, hot winds howl,\nAnd lightning creeps in clouds with shame.\n\nOverhead, water sheds,\nIt pitters patterns in your ear.\nNever meek, storms that speak,\nAnd tell you that it’s them you seek.\n\nLet it call. Feel the storm,\nLet the falling world be warm.\nFor when it leaves, when it’s light,\nWhat a frightening sound and sight?\n\nWarmer winds, gone away,\nNow the silence of the day.`,
//         author: "Benjamin Gagliardi"
//     },
//     // {
//     //     title: "Empty Sea",
//     //     style: "Drama",
//     //     year: 2023,
//     //     lines: `I’ve wasted every drop of grace,\nRighteous anger burns in my face,\nWhy can’t I stop the endless drain,\nBefore the water’s gone again,\nAs I stare at the empty sea,\nHow can you save me?\n\nYou want to see a coward?\nLook no further, than the hours\nof my murder.\n\nI’ve painted my deliverance\nWith a prideful independence,\nYet it’s clear to me that painted lines\nLack truth when they are only mine.\nIs it not too late for saving?\nIs it not far too much failing?\n\nChill my heart and freeze my hands,\nTake my soul and kill my plans,\nPierce my chest with hope and grace,\nHold me fast to see your face.\nOne day waves won’t sink from sight,\nOne day waves will drown my plight.\n\nI cry, I cry, in deep, these seas,\nWith tears impossible to see,\nI have no hope with any plea,\nJust dark surrender to the deep,\nCrush me all to set me free.`,
//     //     author: "Benjamin Gagliardi"
//     // },
//     {
//         title: "Sitting at My Desk Today",
//         style: "Drama",
//         year: 2022,
//         lines: `Bare white walls on a sunny day,\nAnd silent prayers to run away.\nA quiet God that answers not,\nA quiet room, a quiet thought.\n\nShuttered blinds on a sunny day,\nNo welcome light, or sunny ray,\nBut the cracks of cold white eyes peer,\nThrough cracks of blinds come reaching near.\n\nFrigid room on a sunny day,\nCold fingers and cold toes today,\nA numb body without its fear,\nA numb heart to hold nothing dear.\n\nDoing nothing on a sunny day,\n         As time bleeds time away.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Hollowpoints",
//         style: "Drama",
//         year: 2022,
//         lines: `Hollow points in my mind,\nRip and tear their design:\nA riddled, rotting, brain,\nWhere all the blood has drained.\nI feel like Nothing changed,\nThen all at once I rearrange,\nWretched noises bright and empty,\nRattle through my head and tempt me,\nHallowed colors\n      in my hollow eyes\n            lose their hue.\nAnd all that’s bad is made new.\nAir in my throat catches stale in my frame.\nThe earth stops turning and turns all the same.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Open Eyes",
//         style: "Drama",
//         year: 2021,
//         lines: `I could not sleep, I could not close my eyes,\nMary said I had so much love to give,\nBut never said who I should give it to.\nAnd when I think of all the people I\nHave met it feels my heart is going to burst,\nSo, like a paper cup that’s overfilled,\nAnd cracks its sides from water that has spilled,\nI love and love and love to all\nBut lie in love, and rise to fall.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Bittertime",
//         style: "Drama",
//         year: 2020,
//         lines: `I went back home the other day,\nIt was the first Sunday of May.\nThe Spring had climbed up to the glass,\nThe weeds had grown in years that passed,\nAnd so I tread across the grass.\n\nI smell a stranger in my shirt,\nAnd see the age that tracked in dirt,\nTo halls and rooms I grew up in,\nI do not know how to begin,\nTo make the house feel young again.\n\nThough my heart feels every sound,\nAnd ridges closer to the ground,\nI trace new lines upon the wood,\nAnd stand up taller than I’ve stood,\nNothing up here feels like it should.\n\nThis house that tasted every fall,\nAnd every spring and shared them all,\nWith everyone I used to love.\nThe wooden sky, this roof above,\nHas moved in clouds I don’t know of.\n\nThere is no peace within the mind,\nWhen you can just go back in time\nAlone, and every voice you find,\nIs just an echo in your mind.\nYou might find it a bitter time.\n\nThe quiet sounds like time I lost,\nThe warmth of something now a frost,\nThe seasons that I left behind,\nAre just more reasons in my mind,\nIt truly is a bitter time.\n\nIt begs and pleads for us to change,\nThis time that leaves all good things strange,\nWhile helping stars to pass us by,\nUntil it is an unfamiliar sky,\nAnd life is now the bitter time.`,
//         author: "Benjamin Gagliardi"
//     },
//     {
//         title: "Addicts Creed",
//         style: "Drama",
//         year: 2020,
//         lines: `Just listen to the rain.\nEach pitter is your pattern,\nAnd each patter is your pain.\nBut you don’t see, or hear, or feel,\nThe rain until it’s gone away,\nSo now before the drips you kneel,\nAnd hate the quiet of the day.`,
//         author: "Benjamin Gagliardi"
//     },
// ];
const poems = [];

// const music = [
//     {
//         title: "Hollowpoints",
//         style: "Choral",
//         year: 2026,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: "https://musescore.com/user/28994480/scores/31764482"
//     },{
//         title: "Seluna",
//         style: "Choral",
//         year: 2025,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: "https://musescore.com/user/28994480/scores/27541243"
//     },
//     {
//         title: "Sefrinuum",
//         style: "Piano / Strings",
//         year: 2025,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: "https://musescore.com/user/28994480/scores/21761614/s/6stvD8"
//     },
//     {
//         title: "Steeple Waltz",
//         style: "Piano",
//         year: 2024,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: ""
//     },
//     {
//         title: "Go With You",
//         style: "Piano / Strings",
//         year: 2024,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: ""
//     },
//     {
//         title: "Iodorae",
//         style: "Piano",
//         year: 2023,
//         description: "",
//         author: "Benjamin Gagliardi",
//         link: "https://musescore.com/user/28994480/scores/21640252"
//     },
// ];
const music = []

const portfolio = {
    plays: plays,
    screenplays: screenplays,
    poems: poems,
    skits: skits,
    music: music
}

export default portfolio;

